import React from 'react';
import '../../styles/Loader.css';

const Loader = () => (
  <div className="loader-overlay">
    <div className="loader-container">
      <div style={{
        fontFamily: 'var(--font-accent, "Playfair Display", serif)',
        fontSize: '1.6rem',
        fontWeight: 600,
        letterSpacing: '0.25em',
        textTransform: 'uppercase',
        color: 'var(--text-primary, #1a1a1a)',
        animation: 'loaderPulse 1.5s ease-in-out infinite'
      }}>
        REM URBAN
      </div>
    </div>
    <style>{`
      @keyframes loaderPulse {
        0%, 100% { opacity: 0.4; }
        50% { opacity: 1; }
      }
    `}</style>
  </div>
);

export default Loader;
